import { AttentionRest } from "@/services/rest/attention.rest";
import { MediaPermissionsError } from "mic-check";
import { BehaviorSubject, EMPTY, Subject } from "rxjs";
import { AttentionResult } from "./landmarks/get-attention-level";

export class AttentionService {
  constructor(private _attention = new AttentionRest()) {}

  private static attention$ = new Subject<AttentionResult>();
  static attention = this.attention$.asObservable();
  static setAttention(value): void {
    AttentionService.attention$.next(value);
  }

  static detectorFaces = new BehaviorSubject({} as any);

  stream: MediaStream | undefined;
  video: HTMLVideoElement | undefined;
  static error: BehaviorSubject<any> = new BehaviorSubject(null);
  hasPermission: boolean = false;

  async startCamera(video: HTMLVideoElement) {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      await navigator.mediaDevices
        .getUserMedia({
          video: {
            frameRate: { min: 20, max: 30 },
          },
          audio: false,
        })
        .then((stream) => {
          if (stream) {
            video.srcObject = stream;
            this.stream = stream;
            this.video = video;
            AttentionService.error.next(false);
            this.hasPermission = true;
          }
        })
        .catch((error: MediaPermissionsError) => {
          this.hasPermission = false;
          const { message } = error;
          if (message) {
            AttentionService.error.next(true);
          }
        });
    }
  }

  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }

  startDetection(files: HTMLImageElement[] | File[], fps: number): void {
    if (this.hasPermission) {
      this._attention
        .startDetector(files, fps)
        .then((response) => {
          AttentionService.attention$.next(response);
        })
        .catch((error) => {
          console.error("Could not get video.");
          console.error(error);
          if (this.stream) {
            this.stream.getTracks().forEach((track) => {
              track.stop();
            });
          }
          return EMPTY;
        });
    }
  }
}
